import type { FC } from 'react';
import React, { useContext } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import LikeIcon from '@atlaskit/icon/core/thumbs-up';
import CommentIcon from '@atlaskit/icon/core/comment';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Inline from '@atlaskit/primitives/inline';
import Flex from '@atlaskit/primitives/components/flex';
import { xcss } from '@atlaskit/primitives/xcss';

import { PageCardContext } from '../PageCardContext.ts';

const i18n = defineMessages({
	likes: {
		id: 'page-card.social.likes',
		defaultMessage: 'likes',
		description: 'Icon to show how many people like a page.',
	},
	comments: {
		id: 'page-card.social.comments',
		defaultMessage: 'comments',
		description: 'Icons to show how many people commented on a page.',
	},
});

const socialProofContainerStyles = xcss({
	color: 'color.text.subtlest',
});

const countStyles = xcss({
	font: 'font.body.small',
	marginLeft: 'space.025',
	fontWeight: 'font.weight.regular',
});

type SocialProofProps = {
	isInlineAction?: boolean;
};

export const SocialProof: FC<SocialProofProps> = () => {
	const { likesCount, commentsCount } = useContext(PageCardContext);
	const intl = useIntl();

	return (
		<Flex alignItems="center" xcss={socialProofContainerStyles} columnGap="space.150">
			{likesCount ? (
				<Flex alignItems="center" columnGap="space.025">
					<LikeIcon label={intl.formatMessage(i18n.likes)} />
					<Inline xcss={countStyles}>{likesCount}</Inline>
				</Flex>
			) : null}
			{commentsCount ? (
				<Flex alignItems="center" columnGap="space.025">
					<CommentIcon label={intl.formatMessage(i18n.comments)} />
					<Inline xcss={countStyles}>{commentsCount}</Inline>
				</Flex>
			) : null}
		</Flex>
	);
};
